import React, { useContext } from 'react';
import IntlContext from '@jetshop/intl/context';
import formatMessage from 'format-message/types';

export const useIntl = () => useContext(IntlContext);

type FormatMsgType = typeof formatMessage;
type FormatMsgTypes =
  | FormatMsgType
  | FormatMsgType['rich']
  | FormatMsgType['number']
  | FormatMsgType['date']
  | FormatMsgType['time']
  | FormatMsgType['select']
  | FormatMsgType['plural']
  | FormatMsgType['selectordinal']
  | FormatMsgType['custom'];

type WithContextFormatMessage = ReturnType<typeof withContextFormatMessage>;

interface TranslateType extends WithContextFormatMessage {
  rich: (
    ...args: Parameters<FormatMsgType['rich']>
  ) => ReturnType<WithContextFormatMessage>;
  number: (
    ...args: Parameters<FormatMsgType['number']>
  ) => ReturnType<WithContextFormatMessage>;
  date: (
    ...args: Parameters<FormatMsgType['date']>
  ) => ReturnType<WithContextFormatMessage>;
  time: (
    ...args: Parameters<FormatMsgType['time']>
  ) => ReturnType<WithContextFormatMessage>;
  select: (
    ...args: Parameters<FormatMsgType['select']>
  ) => ReturnType<WithContextFormatMessage>;
  plural: (
    ...args: Parameters<FormatMsgType['plural']>
  ) => ReturnType<WithContextFormatMessage>;
  selectordinal: (
    ...args: Parameters<FormatMsgType['selectordinal']>
  ) => ReturnType<WithContextFormatMessage>;
  custom: (
    ...args: Parameters<FormatMsgType['custom']>
  ) => ReturnType<WithContextFormatMessage>;
}

const withContextFormatMessage =
  (callback: (t: FormatMsgType) => ReturnType<FormatMsgTypes>) =>
  (...args: Parameters<FormatMsgTypes>) =>
    React.createElement(IntlContext.Consumer, null, (t: FormatMsgType) =>
      callback(t)(...args)
    );

const Translate = withContextFormatMessage((t) => t) as TranslateType;
Translate.rich = withContextFormatMessage((t) => t.rich);
Translate.number = withContextFormatMessage((t) => t.number);
Translate.date = withContextFormatMessage((t) => t.date);
Translate.time = withContextFormatMessage((t) => t.time);
Translate.select = withContextFormatMessage((t) => t.select);
Translate.plural = withContextFormatMessage((t) => t.plural);
Translate.selectordinal = withContextFormatMessage((t) => t.selectordinal);
Translate.custom = withContextFormatMessage((t) => t.custom);

export const Intl = IntlContext.Consumer;
export default Translate;
